if($('.sticky-under-navbar')) {
    $('.sticky-under-navbar').css("top", $('.navbar-main').outerHeight(true));
}

if($('.block-list_images').hasClass("sidebar-width-translate")) {
    var sidebarWidth = $(".sidebar-collapsible").width();
    var contentOffest = sidebarWidth + 24;
    $(".slider-content__text__item").css("padding-left", contentOffest);
    $(".slider-content__text__item").css("padding-right", contentOffest);
}
